module.exports = require("os");


/*****************
 ** WEBPACK FOOTER
 ** external "os"
 ** module id = 27
 ** module chunks = 0
 **/